import AzurePluginInterface from '@/utilities/auth/azure/interfaces/AzurePluginInterface'
import TokenInterface from '@/utilities/auth/azure/interfaces/TokenInterface'
import TokenManagerInterface from '@/utilities/auth/azure/interfaces/TokenManagerInterface'

class TokenManager implements TokenManagerInterface {
  keys: { clientId: string; tenantId: string }
  localStorage: Storage

  constructor(azure: AzurePluginInterface, localStorage: Storage) {
    this.keys = azure?.apiKey
    this.localStorage = localStorage
  }

  getLocalStorage(): Storage {
    return this.localStorage
  }

  getTokens(): TokenInterface {
    const resp: TokenInterface = { token: '', refresh: '', access: '' }
    for (const item in this.localStorage) {
      if (item.match(new RegExp(`login.windows.net-idtoken-${this.keys.clientId}-`, 'g'))) {
        const storage = JSON.parse(this.localStorage.getItem(item) ?? '')
        resp.token = storage.secret
      }
      if (item.match(new RegExp(`login.windows.net-accesstoken-${this.keys.clientId}-`, 'g'))) {
        const storage = JSON.parse(this.localStorage.getItem(item) ?? '')
        resp.access = storage.secret
      }
      if (item.match(new RegExp(`login.windows.net-refreshtoken-${this.keys.clientId}--`, 'g'))) {
        const storage = JSON.parse(this.localStorage.getItem(item) ?? '')
        resp.refresh = storage.secret
      }
    }
    return resp
  }
}

export default TokenManager
